import Expandable from './expandable';

export default Expandable;
